import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { Checkbox, Notification } from 'wix-style-react'
import * as _ from 'lodash'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { displayError } from 'components/NotificationController'
import { setCustomFieldArray } from 'controllers/logic'
import { assetRemoved } from 'controllers/assets'
import { removeFromStorage, uploadToStorage, uploadToStorageVideo } from 'controllers/storage'
import emptyStateIcon from 'assets/empty_state_image_icon.png'
import { media, TEAL, HELVETICA, CustomScrollBar } from 'components/styles'

import { processImage,
         processVideo,
         VIDEO_FILETYPES,
         IMAGE_FILETYPES } from 'utils/uploadUtils'

import AssetCard from 'components/editor/assetsManager/AssetCard'
import Droppable from 'components/editor/assetsManager/Droppable'
import UploadDisclimer from 'components/editor/assetsManager/UploadDisclimer'
import Pagination from 'components/shared/Pagination'

const MainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0em;
`
const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  _height: 30em;
  overflow-y: auto;
  ${CustomScrollBar}
`

const AssetsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  padding-top: 0.4em;

  & > div {
    outline: none;
  }
`
const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 5em;
`
const EmptyStateImage = styled.img`
  width: auto;
  ${media.small`height: 100px; margin: 15px 0px 35px 0px;`}
  ${media.huge`height: 150px; margin: 15px 0px 35px 0px;`}
`
const EmptyStateText = styled.div`
  color: ${TEAL};
  ${HELVETICA};
  opacity: 0.4;
  font-size: 120%;
`

const PaginationContainer = styled.div`
  margin-top: 1em;
  align-self: center;
`
const ITEMS_COUNT_PER_PAGE = 15

class ShopifyAssetsSelector extends Component {

  constructor (props) {
    super(props)
    this.state = {
      activePage: 1,
      assets: this.makeAssets(props)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (_.size(nextProps.assets) !== _.size(this.props.assets) ||
        nextProps.shopifyAppAssets.length !== this.props.shopifyAppAssets.length) {
      this.setState({
        assets: this.makeAssets(nextProps)
      })
    }
  }

  select (data) {
    const { appId, dispatch, path, currentValue } = this.props
    if (_.isArray(currentValue)) {
      // unselect the asset
      const newCurrentValue = _.clone(currentValue)
      if (currentValue.indexOf(data) >= 0) {
        _.remove(newCurrentValue, elt => elt === data)
      } else {
        newCurrentValue.push(data)
      }
      dispatch(setCustomFieldArray(appId, path, newCurrentValue))
    } else {
      if (data === currentValue || (data.url && data.url === currentValue.url)) {
        dispatch(setCustomFieldArray(appId, path, null))
      } else {
        dispatch(setCustomFieldArray(appId, path, data))
      }
    }
  }

  onAssetClick = (asset) => {
    const { onAssetClick } = this.props
    if (onAssetClick) {
      return () => {
        onAssetClick(asset)
      }
    } else {
      return () => {
        const { isVideo } = this.props
        if (isVideo) {
          const data = {
            url: asset.url,
            thumbUrl: asset.thumb.url
          }
          this.select(data)
        } else {
          this.select(asset.url)
        }
      }
    }
  }

  isSelected = (url) => {
    const { currentValue } = this.props
    if (_.isNil(currentValue)) {
      return _.isNil(url)
    } else if (_.isString(currentValue)) {
      return url === currentValue
    } else if (_.isArray(currentValue)) {
      return currentValue.indexOf(url) >= 0
    } else if (_.isObject(currentValue)) {
      return url === currentValue.url
    } else {
      return false
    }
  }

  onDelete = (asset) => {
    const { dispatch, appId, onAssetDeleted } = this.props
    if (appId) {
      if (_.has(asset, ['thumb', 'id'])) {
        dispatch(removeFromStorage(appId, asset.thumb.id))
      }
      dispatch(removeFromStorage(appId, asset.id))
      dispatch(assetRemoved(asset))
      onAssetDeleted(asset)
    }
  }

  renderAsset = (asset, id) => {
    const { isVideo, appId } = this.props
    if ((!isVideo && asset.type !== 'video') || (isVideo && asset.type === 'video')) {
      let onDelete
      if (_.has(asset, 'uploadedAt')) onDelete = this.onDelete
      return (
        <AssetCard
          key={id}
          appId={appId}
          asset={asset}
          onSet={this.onAssetClick(asset)}
          isSelected={this.isSelected(asset.url)}
          onDelete={onDelete}
        />
      )
    }
  }

  makeAssets (props) {
    const { assets, shopifyAppAssets, showNoneOption } = props
    const allAssets = _.concat(_.values(assets), shopifyAppAssets)
    const sortedAssets =
      _.sortBy(allAssets, [ (a) => {
        if (a.uploadedAt) {
          return -a.uploadedAt
        } else {
          return 0
        }
      }])
    if (showNoneOption) {
      sortedAssets.unshift({
        id: 0,
        name: '',
        url: null
      })
    }
    return sortedAssets
  }

  renderEmptyState () {
    return (
      <EmptyStateContainer>
        <EmptyStateImage src={emptyStateIcon} />
        <EmptyStateText>Upload some images to get started</EmptyStateText>
      </EmptyStateContainer>
    )
  }

  renderAllAssets () {
    const { assets, activePage } = this.state
    const assetsOnPage = _.slice(assets, ITEMS_COUNT_PER_PAGE * (activePage - 1), ITEMS_COUNT_PER_PAGE * activePage)
    // console.log('renderAllAssets assets count', _.size(assets), 'shopifyAppAssets count', shopifyAppAssets.length)
    // console.log('assets on page', assetsOnPage)
    return (
      <AssetsContainer>
        {/* {_.map(shopifyAppAssets, (asset, id) => { return this.renderShopifyAsset(asset, id) })} */}
        {_.map(assetsOnPage, this.renderAsset)}
      </AssetsContainer>
    )
  }

  onDropAccepted = (file) => {
    const { dispatch, appId } = this.props

    if (this.props.isVideo) {
      processVideo(file).then(({videoFile, imageFile}) => {
        dispatch(uploadToStorageVideo(appId, videoFile, imageFile))
      }).catch(reason => {
        displayError(`${file.name} file upload failed.`)
      })
    } else {
      processImage(file).then((fileToUpload) => {
        dispatch(uploadToStorage(appId, fileToUpload))
      }).catch(reason => {
        displayError(`${file.name} file upload failed.`)
      })
    }
  }

  onDropRejected = (file) => {
    displayError(`${file.name} has unaccepatable extension of file.`)
  }

  onPaginationChange = (v) => {
    this.setState({
      activePage: v
    })
  }

  render () {
    const { activePage, assets } = this.state
    const filetypes = this.props.isVideo ? VIDEO_FILETYPES : IMAGE_FILETYPES
    const assetsAmount = assets.length
    return (
      <Droppable
        dragOverlay={<UploadDisclimer />}
        onDropAccepted={this.onDropAccepted}
        onDropRejected={this.onDropRejected}
        filetypes={filetypes}
      >
        <MainContainer scrollable={assetsAmount > 0}>
          <DataContainer>
            {(assetsAmount > 0) ? this.renderAllAssets() : this.renderEmptyState()}
          </DataContainer>
          <PaginationContainer>
            <Pagination
              activePage={activePage}
              itemsCountPerPage={ITEMS_COUNT_PER_PAGE}
              totalItemsCount={assetsAmount}
              pageRangeDisplayed={5}
              onChange={this.onPaginationChange}
            />
          </PaginationContainer>
        </MainContainer>
      </Droppable>
    )
  }
}

ShopifyAssetsSelector.defaultProps = {
  isVideo: false,
  currentValue: {},
  assets: {},
  shopifyAppAssets: [],
  showNoneOption: false,
  onAssetDeleted: () => null
}

ShopifyAssetsSelector.propTypes = {
  isVideo: PropTypes.bool,
  currentValue: PropTypes.oneOfType([ PropTypes.object, PropTypes.string, PropTypes.array ]),
  assets: PropTypes.object,
  shopifyAppAssets: PropTypes.array,
  path: PropTypes.array.isRequired,
  appId: PropTypes.string.isRequired,
  onAssetClick: PropTypes.func,
  showNoneOption: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  onAssetDeleted: PropTypes.func
}

const mapStateToProps = (state) => ({
  shopifyAppAssets: state.shopifyAppData.assets
})

export default connect(mapStateToProps)(ShopifyAssetsSelector)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/ShopifyAssetsSelector.js